import http from "../../http-common";

class AutresDataService {

  upload(file, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);

    return http.post("/fichierautres/upload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }

  getFiles() {
    return http.get("/fichierautres/getListFiles");
  }

  getAll() {
    return http.get("/autres");
  }

  get(id) {
    return http.get(`/autres/${id}`);
  }

  create(data) {
    return http.post("/autres", data);

  }

  update(id, data) {
    return http.put(`/autres/${id}`, data);
  }

  delete(id) {
    return http.delete(`/autres/${id}`);
  }

  deleteAll() {
    return http.delete(`/autres`);
  }

  findByTitle(Nom) {
    return http.get(`/autres?nom=${Nom}`);
  }
}

export default new AutresDataService();